import { IMainNavbarSuggestion } from 'components/shared/nav/components/NavBarSearch';

export const isObjectEmpty = (object: object) => {
  return object ? Object.keys(object).length === 0 : true;
};

export const isPropertyObject = (option: IMainNavbarSuggestion) => {
  return Object.keys(option).includes('propertyType') && option.propertyType;
};
